import {Helmet} from "react-helmet";
import FeaturedProducts from '../FeaturedProducts/FeaturedProducts'
import CategorySlider from '../CategorySlider/CategorySlider'

export default function Home() {
	return (
		<>
		<CategorySlider/>
		<FeaturedProducts/>
		<h1>Welcome home</h1>
		<Helmet>
			<title>Home</title>
		</Helmet>
		</>
	)
}
